import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@ao-internal/components-react';

import { BottomSheetHeaderProps } from './types';

export const BottomSheetHeader = React.forwardRef<
	HTMLButtonElement,
	BottomSheetHeaderProps
>(({ onClose }, ref) => {
	const { t } = useTranslation();

	return (
		<React.Fragment>
			<div
				data-testid="chatbot-bottom-sheet-header"
				className="flex justify-end p-4"
			>
				<button
					ref={ref}
					data-tag-name="close cta"
					data-testid="close-bottom-sheet-cta"
					type="button"
					onClick={onClose}
					className="flex items-center justify-center p-0 bg-white rounded cursor-pointer"
				>
					<span className="sr-only">{t('bottomSheet:closeCta')}</span>
					<Icon icon="close" size="2x" className="text-cta-action" />
				</button>
			</div>
		</React.Fragment>
	);
});

export default BottomSheetHeader;
